import React, { useContext, useEffect, useState } from 'react';
import { Box, FormControl, FormControlLabel, Grid, Hidden, Radio, RadioGroup, Typography } from '@mui/material';
import StepperManagement from '../components/stepperManagement';
import PropertyCard from '../components/propertyCard';
import { makeStyles } from 'tss-react/mui';
import { AppContext } from '../../../../utils/appContext';
import { useTranslation } from 'react-i18next';
import visa from '../../../../assets/img/visa.svg';
import mastercard from '../../../../assets/img/mastercard.svg';
import maestro from '../../../../assets/img/maestro.png';
import paypal from '../../../../assets/img/paypal.png';
import scalapay from '../../../../assets/img/scalapay.png';
import bank from '../../../../assets/img/bank.svg';
import Card from '../step3/payments/Card';
import BankTransfer from './payments/BankTransfer';
import Paypal from './payments/Paypal';
import ScalaPayMethod from './payments/Scalapay';
import { getReservationsByToken, getRoomTypeDetails } from '../../../../utils/requests';
import { AxiosResponse } from 'axios';
import { Reservation } from '../../../../interfaces/bookingContext';
import { IAccommodationMoreInfo } from '../../../../interfaces/huWebsite';
import { getProperties } from '../../../../utils/helpers';

const Payment = () => {
  const useStyles = makeStyles()((theme) => {
    return {
      bookingDetails: {
        b: {
          alignItems: 'center',
          fontFamily: theme.typography.h1.fontFamily,
          '& svg': {
            color: '#2357D0',
            fontSize: 16,
            marginRight: 5
          }
        },
        p: {
          fontFamily: theme.typography.body1.fontFamily
        },
        h5: {
          fontSize: 22
        },
        [theme.breakpoints.down('sm')]: {
          marginTop: '30px'
        }
      },
      stepperContainer: {
        [theme.breakpoints.down('sm')]: {
          backgroundColor: '#f5f5f1'
        }
      }
    };
  });

  const { classes } = useStyles();
  const appContext = useContext(AppContext);

  const keyPaymentMethods =
    process.env.NODE_ENV === 'development' ? 'payment_methods_test' : 'payment_methods';
  const [methods, setMethods] = useState<string[]>([]);

  useEffect(() => {
    const configs = appContext.getProperty(appContext.website);
    if (configs && configs[keyPaymentMethods]) {
      setMethods(configs[keyPaymentMethods].map((p: any) => p.name));
    }
  }, []);

  const { t } = useTranslation();
  const [resDetails, setResDetails] = useState<any>({});
  const [roomTypeInfo, setRoomTypeInfo] = useState<IAccommodationMoreInfo>();

  const handlePayment = (event: React.ChangeEvent<HTMLInputElement>) => {
    appContext.setPayment((event.target as HTMLInputElement).value);
  };

  useEffect(() => {
    getReservationsByToken()
      .then((response: AxiosResponse) => {
        setResDetails(response.data[0]);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [localStorage.getItem('token_bookings_management')]);

  const howPaid = (reservation: Reservation): number => {
    let Paid = 0;
    reservation.Postings.filter((posting: any) => posting.DepartmentType === '3').map(
      (posting: any) => (Paid += parseFloat(posting.PostingPrice))
    );
    // check payment with points
    reservation.Postings.filter(
      (posting: any) => posting.DepartmentType === '1' && posting.DepartmentCode === '136'
    ).map((posting: any) => (Paid += Math.abs(parseFloat(posting.PostingPrice))));
    return Paid;
  };

  const howToPay = (reservation: Reservation): number => {
    return parseFloat(reservation.TotalStay) - howPaid(reservation);
  };

  const property = getProperties().find(
    (property) => property.code === appContext.searchForm[0].property
  );

  useEffect(() => {
    if (property) {
      getRoomTypeDetails({ url: property.room_info_end_point + resDetails.RoomType })
        .then((response: AxiosResponse<IAccommodationMoreInfo>) => {
          setRoomTypeInfo(response.data);
        })
        .catch();
    }
  }, [resDetails]);

  return (
    <Box mt={5} pt={2}>
      <Grid container direction={'row'} justifyContent={'center'} alignItems={'center'}>
        <Grid item md={11}>
          <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.stepperContainer}>
              <StepperManagement step={2} />
            </Grid>
            <Grid item xs={10} sm={8} sx={{ margin: 'auto' }}>
              <Grid
                container
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}>
                <Grid item sm={11} md={5}>
                  <Box className={classes.bookingDetails} mb={3}>
                    <Grid
                      container
                      direction={'row'}
                      justifyContent={'center'}
                      alignItems={'center'}>
                      <Grid item xs={12}>
                        <Grid item>
                          <Typography variant={'body1'} component={'p'}>
                            Pagamento
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid item>
                          <Typography variant={'h6'} component={'b'}>
                            Importo da pagare
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid item></Grid>
                        {resDetails.Postings && (
                          <Grid item textAlign={'right'}>
                            <Typography
                              variant={'body1'}
                              component={'b'}
                              style={{
                                display: 'inline-flex',
                                borderBottom: '4px solid rgb(255, 182, 74)',
                                lineHeight: '0.4'
                              }}>
                              € {howToPay(resDetails)}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>

                    <Grid item md={12} mt={4} mb={4}>
                      <hr style={{ border: '4px solid #F4F3EF' }} />
                    </Grid>

                    <Typography variant={'h5'} component={'h5'}>
                      Ci siamo quasi.
                      <br /> Scegli il tuo metodo di pagamento preferito.
                    </Typography>

                    <Grid item xs={12} sx={{ marginTop: { xs: '37px', md: '10px' } }}>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={appContext.payment}
                          onChange={handlePayment}
                          style={{ clipPath: 'inset(-100vw -100vw -100vw 0)' }}>
                          {appContext.website !== 'BK' && (
                            <FormControlLabel
                              style={{
                                padding: '10px 0',
                                borderBottom: '1px solid black',
                                marginRight: 0
                              }}
                              value="card"
                              control={<Radio />}
                              label={
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="flex-start"
                                  alignItems="stretch">
                                  <Grid item xs={7}>
                                    <Box width={'100%'}>
                                      <Typography
                                        variant={'body1'}
                                        component={'p'}
                                        style={{ fontWeight: 600 }}>
                                        {t('credit_or_debit_card')}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={5}
                                    style={{
                                      textAlign: 'right',
                                      alignItems: 'center',
                                      display: 'flex',
                                      justifyContent: 'flex-end'
                                    }}>
                                    <Box
                                      style={{
                                        boxShadow: '0px 8px 16px #00000029',
                                        borderRadius: 24,
                                        padding: '5px 10px 0 10px'
                                      }}>
                                      <img
                                        src={visa}
                                        style={{ maxWidth: 20, height: 14, padding: '0 5px' }}
                                      />
                                      <img
                                        src={maestro}
                                        style={{ maxWidth: 25, height: 14, padding: '0 5px' }}
                                      />
                                      <img
                                        src={mastercard}
                                        style={{ maxWidth: 20, height: 14, padding: '0 5px' }}
                                      />
                                    </Box>
                                  </Grid>
                                </Grid>
                              }
                            />
                          )}

                          {methods.includes('paypal') && (
                            <FormControlLabel
                              style={{
                                padding: '10px 0',
                                borderBottom: '1px solid black',
                                marginRight: 0
                              }}
                              value="paypal"
                              control={<Radio />}
                              label={
                                <span>
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center">
                                    <Grid item xs={8}>
                                      <Box width={'100%'}>
                                        <Typography
                                          variant={'body1'}
                                          component={'p'}
                                          style={{ fontWeight: 600 }}>
                                          PayPal
                                        </Typography>
                                      </Box>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={4}
                                      style={{
                                        textAlign: 'right',
                                        alignItems: 'center',
                                        display: 'flex',
                                        justifyContent: 'flex-end'
                                      }}>
                                      <Box
                                        style={{
                                          boxShadow: '0px 8px 16px #00000029',
                                          borderRadius: 24,
                                          padding: '5px 10px 0 10px'
                                        }}>
                                        <img src={paypal} style={{ maxWidth: 10 }} />
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </span>
                              }
                            />
                          )}

                          {methods.includes('scalapay') &&
                            appContext.language.toLowerCase() !== 'en' &&
                            appContext.language.toLowerCase() !== 'pl' && (
                              <FormControlLabel
                                style={{
                                  borderBottom: '1px solid #707070',
                                  padding: '10px 0',
                                  marginRight: 0
                                }}
                                value="scalapay"
                                control={<Radio />}
                                label={
                                  <span>
                                    <Grid
                                      container
                                      direction="row"
                                      justifyContent="flex-start"
                                      alignItems="center">
                                      <Grid item xs={8}>
                                        <Box width={'100%'}>
                                          <Typography
                                            variant={'body1'}
                                            component={'p'}
                                            style={{ fontWeight: 600 }}>
                                            Scalapay
                                          </Typography>
                                        </Box>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={4}
                                        style={{
                                          textAlign: 'right',
                                          alignItems: 'center',
                                          display: 'flex',
                                          justifyContent: 'flex-end'
                                        }}>
                                        <Box
                                          style={{
                                            boxShadow: '0px 8px 16px #00000029',
                                            borderRadius: 24,
                                            padding: '5px 10px 0 10px'
                                          }}>
                                          <img src={scalapay} style={{ maxWidth: 40 }} />
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </span>
                                }
                              />
                            )}

                          <FormControlLabel
                            style={{
                              borderBottom: '1px solid #707070',
                              padding: '10px 0',
                              marginRight: 0
                            }}
                            value="bank"
                            control={<Radio />}
                            label={
                              <span>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="flex-start"
                                  alignItems="center">
                                  <Grid item xs={8}>
                                    <Box width={'100%'}>
                                      <Typography
                                        variant={'body1'}
                                        component={'p'}
                                        style={{ fontWeight: 600 }}>
                                        Bonifico bancario
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={4}
                                    style={{
                                      textAlign: 'right',
                                      alignItems: 'center',
                                      display: 'flex',
                                      justifyContent: 'flex-end'
                                    }}>
                                    <Box
                                      style={{
                                        boxShadow: '0px 8px 16px #00000029',
                                        borderRadius: 24,
                                        padding: '5px 10px 0 10px'
                                      }}>
                                      <img src={bank} style={{ maxWidth: 40, height: 14 }} />
                                    </Box>
                                  </Grid>
                                </Grid>
                              </span>
                            }
                          />
                        </RadioGroup>
                      </FormControl>

                      <Box mt={2}>
                        {appContext.payment === 'card' && <Card />}

                        {appContext.payment === 'paypal' && <Paypal />}

                        {appContext.payment === 'scalapay' && <ScalaPayMethod />}

                        {appContext.payment === 'bank' && <BankTransfer />}
                      </Box>
                    </Grid>
                  </Box>
                </Grid>
                <Hidden mdDown>
                  <Grid item md={5}>
                    <PropertyCard reservation={resDetails} room={roomTypeInfo} />
                  </Grid>
                </Hidden>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Payment;
